import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class CurSearchUseCase extends BaseUseCase {
    constructor(Repo) {
        super();
        this.Repo = Repo;
    }
    async fetchResult(data) {
        return await this.Repo.getCurSearch(data);
    }
}
export default CurSearchUseCase;
